import axios from "axios";
import config from "../../config/environment";

const DJANGOCALLER_PATH = config.DJANGOCALLER_PATH || "/djangocaller";
const DJANGOCALLER_API_BASE_URL =
  config.DJANGOCALLER_API_BASE_URL ||
  config.BACKEND_URL ||
  "https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production";

const djangocallerClient = axios.create({
  baseURL: DJANGOCALLER_API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

export const extractPrimitiveFieldValue = (value) => {
  let current = value;
  while (
    current &&
    typeof current === "object" &&
    !Array.isArray(current) &&
    Object.prototype.hasOwnProperty.call(current, "value")
  ) {
    current = current.value;
  }
  return current;
};

export const buildGetDDFieldsFromParams = (params = [], fields = []) => {
  if (!Array.isArray(params)) return [];
  const bodyField = fields.find((field) => field?.name === "body");
  const bodyValue =
    bodyField && bodyField.value && typeof bodyField.value === "object" ? bodyField.value : undefined;
  return params.map((param) => {
    const match = fields.find((field) => field?.name === param?.name);
    return {
      name: param?.name,
      in: "path",
      value: extractPrimitiveFieldValue(match?.value ?? bodyValue?.[param?.name]),
    };
  });
};

export const getDDDependentValues = (field, workingFields) => {
  const params = field?.schema?.params;
  if (!Array.isArray(params)) return [];
  return params
    .filter((p) => p?.name && p.name !== field?.name)
    .map((p) => {
      const match = workingFields.find((f) => f?.name === p.name);
      return extractPrimitiveFieldValue(match?.value);
    });
};

export const buildGetDDFetchKey = (field, credentialId, appUrl, appSlug, workingFields) => {
  const dynamicParsed = field?.schema?.dynamic || "";
  const performParsed = field?.schema?.perform || "";
  const deps = getDDDependentValues(field, workingFields);
  return [
    field?.name,
    credentialId,
    appUrl,
    appSlug,
    dynamicParsed,
    performParsed,
    JSON.stringify(deps),
  ].join("|");
};

export const parseGetDDRowsToOptions = (responseData, parsed) => {
  if (!parsed) return [];
  const rows = Array.isArray(responseData) ? responseData : [];
  const head = parsed.dataHead || parsed.performDataHead || "0";
  const key = parsed.key || parsed.performKey;
  const value = parsed.value || parsed.performValue;
  const sourceRows =
    head === "0"
      ? rows
      : Array.isArray(responseData?.[head])
        ? responseData[head]
        : [];
  return (sourceRows || [])
    .map((row) => ({ id: row?.[key], name: row?.[value] }))
    .filter((option) => option.id != null && option.name != null);
};

/**
 * Single getDD call via djangocaller. Pass AbortSignal to cancel when deps change (shows as "canceled" in DevTools).
 */
export async function fetchAgentGetDDOptions(
  { url, app, credential, action, fields },
  { signal } = {},
) {
  const res = await djangocallerClient.post(
    DJANGOCALLER_PATH,
    {
      operation: "getDD",
      data: { url, app, credential, action, fields },
    },
    { timeout: 30000, signal },
  );
  return res.data;
}
